import React, {Component} from 'react'
import moment from 'moment'
import {
  CardHeader,
  Avatar,
} from 'material-ui'

import JobCardHeaderTitle from './JobCardHeaderTitle'
import JobCardStatusIndicatorChip from './JobCardStatusIndicatorChip'

export default class JobCardHeader extends Component{
  render(){
    const {job,status,loading} = this.props;
    // let date = moment()
    // if(!loading){date=moment(job.created)}
    return (
      <CardHeader
        title={!!loading ? ' ~ ' : <JobCardHeaderTitle job={job} />}
        subheader={!!loading ? ' ~ ' : job.created!==undefined && job.created!==null? `${job.location} | ${moment(job.created).day()}/${moment(job.created).month()+1}/${moment(job.created).year()}`:`${job.location}`}
        classes={{
          title: !!loading ? 'titleSkeleton' : null,
          subheader: !!loading ? 'subheaderSkeleton' : null,
        }}
        avatar={
          <Avatar
            className={!!loading ? 'avatarSkeleton' : null}
            aria-label={!!loading ? null : job.company}
            src={!!loading ? null : job.logo && job.logo.downloadURLs && job.logo.downloadURLs[0]?job.logo.downloadURLs[0] : null}
          >
            {!!loading ? null : (job.logo && job.logo.downloadURLs && job.logo.downloadURLs[0])?null:job.company[0]}
          </Avatar>
        }
        action={
          !loading && !!status && <JobCardStatusIndicatorChip job={job} />
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCardHeader.js